import { TabsModule } from 'primeng/tabs';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DrawerModule } from 'primeng/drawer';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';
import { MessageService } from 'primeng/api';
import { StepsModule } from 'primeng/steps';
import { AccordionModule } from 'primeng/accordion';
import { InputSwitchModule } from 'primeng/inputswitch';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { PasswordModule } from 'primeng/password';
import { FieldsetModule } from 'primeng/fieldset';
import { providePrimeNG } from 'primeng/config';
import { MyPreset } from '../../myPreset';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { MessageModule } from 'primeng/message';
import { MenuModule } from 'primeng/menu';
import { TagModule } from 'primeng/tag';
import { Select } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { PanelModule } from 'primeng/panel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { DatePickerModule } from 'primeng/datepicker';
import { FocusTrapModule } from 'primeng/focustrap';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { SkeletonModule } from 'primeng/skeleton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CheckboxModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    ListboxModule,
    MessagesModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ScrollPanelModule,
    TableModule,
    ToastModule,
    TooltipModule,
    ChipModule,
    ReactiveFormsModule,
    StepsModule,
    AccordionModule,
    InputSwitchModule,
    DrawerModule,
    BadgeModule,
    OverlayBadgeModule,
    PasswordModule,
    FieldsetModule,
    IconFieldModule,
    InputIconModule,
    MessageModule,
    MenuModule,
    TagModule,
    Select,
    ProgressBarModule,
    TabsModule,
    TextareaModule,
    ToggleSwitchModule,
    PanelMenuModule,
    ConfirmDialogModule,
    PanelModule,
    InputGroupModule,
    InputGroupAddonModule,
    DatePickerModule,
    FocusTrapModule,
    BreadcrumbModule,
    SkeletonModule,
    AutoCompleteModule,
    AvatarModule
  ],
  exports: [
    ButtonModule,
    CalendarModule,
    CardModule,
    CheckboxModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    ListboxModule,
    MessagesModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ScrollPanelModule,
    TableModule,
    ToastModule,
    TooltipModule,
    ChipModule,
    FormsModule,
    ReactiveFormsModule,
    StepsModule,
    AccordionModule,
    InputSwitchModule,
    DrawerModule,
    BadgeModule,
    OverlayBadgeModule,
    InputSwitchModule,
    PasswordModule,
    FieldsetModule,
    IconFieldModule,
    InputIconModule,
    MessageModule,
    MenuModule,
    TagModule,
    Select,
    ProgressBarModule,
    TabsModule,
    TextareaModule,
    ToggleSwitchModule,
    PanelMenuModule,
    ConfirmDialogModule,
    PanelModule,
    InputGroupModule,
    InputGroupAddonModule,
    DatePickerModule,
    FocusTrapModule,
    BreadcrumbModule,
    SkeletonModule,
    AutoCompleteModule,
    AvatarModule
  ],
  providers: [
    DynamicDialogRef,
    DialogService,
    MessageService,
    ConfirmationService,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          prefix: 'p',
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'primeng, tailwind-utilities',
          },
        },
      },
      ripple: true,
    }),
  ]
})
export class PrimeNGModule { }
